@if (editable) {
  <div
    ngbDropdown
    [container]="container"
    [placement]="placement"
    class="jip-dropdown"
    [ngClass]="styleClass"
    [autoClose]="!openOnHover"
    (mouseenter)="onEnterDropdown()"
    (mouseleave)="onLeaveDropdown()"
  >
    @if (!smartTyping) {
      <button
        type="button"
        class="btn jip-dropdown__btn-select w-100 bg-white"
        id="dropdownBasic1"
        ngbDropdownToggle
      >
        <div class="d-flex align-items-center">
          <ng-container *ngTemplateOutlet="dropdownImg"></ng-container>
          <span class="jip-dropdown__selected-text">
            <ng-container *ngTemplateOutlet="normalText"></ng-container>
          </span>
        </div>
      </button>

      <div
        ngbDropdownMenu
        aria-labelledby="dropdownBasic1"
        class="jip-dropdown__menu"
        (mouseenter)="onEnterDropdown()"
        (mouseleave)="onLeaveDropdown()"
      >
        @for (item of items; track item.codeId; let index = $index) {
          <button
            class="d-flex align-items-center"
            ngbDropdownItem
            (click)="select(item, index); dropdown()?.close()"
          >
            <div
              class="d-flex align-items-center"
              [ngClass]="{
                'justify-content-between': item.isAIOption,
              }"
            >
              @if (item.icon) {
                <ng-icon
                  class="dropdown-item-icon me-2"
                  [name]="item.icon"
                  [color]="item.iconColor"
                ></ng-icon>
              }
              @if (item.img) {
                <img
                  appDefaultPlaceholder
                  appDynamicImgUrl
                  [src]="item.img"
                  alt="selection"
                  class="dropdown-img me-2 {{ dropdownImgClass }}"
                />
              }
              <span
                class="text-truncate flex-shrink-0"
                [class.fw-bold]="index === currentIndex"
                >{{ item.value }}</span
              >
              @if (item.isAIOption) {
                <span class="ms-1">
                  <app-ai-indicator></app-ai-indicator>
                </span>
              }
              @if (item?.helpText) {
                <span class="ms-2 text-secondary font-size-md">
                  <ng-icon
                    class="me-2"
                    name="matInfo"
                    [ngbTooltip]="item?.helpText"
                  ></ng-icon>
                </span>
              }
            </div>
          </button>
        }
      </div>
    } @else {
      <ng-select
        #selectComp
        [placeholder]="placeholder | translate"
        [items]="items"
        [multiple]="false"
        bindLabel="value"
        [closeOnSelect]="true"
        [virtualScroll]="true"
        [(ngModel)]="selectedItem"
        [searchFn]="customSearchFn"
        [editableSearchTerm]="true"
        notFoundText="No result found"
        (search)="onSearch($event)"
        groupBy="group"
        (change)="select($event)"
        (focus)="onFocus()"
      >
        <ng-template
          ng-optgroup-tmp
          let-item="item"
        >
          <div
            [ngClass]="{
              'frequently-choice': item.group,
              'frequently-choice-seperator': !item.group,
              'd-none': frequentlyUsedChoice.length === 0,
            }"
          >
            {{ item.group || '' }}
          </div>
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
        >
          {{ item.value }}
        </ng-template>
      </ng-select>
    }
  </div>
} @else {
  <div class="d-flex align-items-center">
    <ng-container *ngTemplateOutlet="dropdownImg"></ng-container>
    <span class="jip-dropdown__selected-text">
      @if (replaceAsStarKey === items[currentIndex]?.codeId) {
        *
      } @else {
        {{ items ? items[currentIndex]?.value : defaultLabel }}
      }
    </span>
  </div>
}

<ng-template #dropdownImg>
  @if (items && items[currentIndex]?.icon) {
    <ng-icon
      class="dropdown-item-icon me-2"
      [name]="items[currentIndex].icon"
      [color]="items[currentIndex].iconColor"
    ></ng-icon>
  }
  @if (items && items[currentIndex]?.img) {
    <img
      appDefaultPlaceholder
      appDynamicImgUrl
      [src]="items[currentIndex]?.img"
      alt="selection"
      class="dropdown-img me-2"
    />
  }
</ng-template>

<ng-template #normalText>
  {{ items ? items[currentIndex]?.value : defaultLabel }}
</ng-template>
